import { render, staticRenderFns } from "./EmployeeAdd.vue?vue&type=template&id=473b38c2&scoped=true&"
import script from "./EmployeeAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b38c2",
  null
  
)

export default component.exports